
import { Drawer, Popover } from "element-ui"
export default {
  components: {
    [Drawer.name]: Drawer,
    [Popover.name]: Popover
  },
  props: {
    wareInfo: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      firstPopoverIndex: null,
      visible: false,
      activeSaveBtn: false,
      storeWareVOList: [],
      showGuide: true,
      drawer: false,
      isShow: false,
      drawerConten: [],
      drawerIndex: undefined
    }
  },
  watch: {
    wareInfo: {
      handler(val) {
        // 初始化所有 pickUpTimes 的 checked 字段为 false
        this.storeWareVOList = val

        // 找到数组中第一个符合条件的索引
        this.firstPopoverIndex = this.storeWareVOList.findIndex(item => item.canChangeTime === 1)
        // <el-popover> 的 v-model="visible" 控制显示，如果此时对应的 DOM 或 storeWareVOList 还没渲染完成，
        // Popover 会找不到参考元素（reference），所以必须延迟才能显示。

        this.$nextTick(() => {
          const flag = localStorage.getItem("firstPopover")
          if (flag) {
            this.visible = false
          } else {
            if (this.firstPopoverIndex !== -1) {
              this.visible = true
              localStorage.setItem("firstPopover", "show")
            }
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},

  methods: {
    gotIt() {
      this.visible = false
    },
    deliveryTimeChang(index) {
      this.drawerIndex = index
      this.drawer = true
      // 深拷贝当前商品的时间项（包含 checked 状态）
      this.drawerConten = this.storeWareVOList[index].pickUpTimes.map(item => ({
        ...item
      }))
      // 设置保存按钮是否激活（当前是否有 checked 项）
      this.activeSaveBtn = this.drawerConten.some(item => item.checked)
      console.log(this.drawerConten, "345354")
    },

    slectAddress(item) {
      if (item.isFull === 1) {
        return
      }
      this.drawerConten = this.drawerConten.map(pick => ({
        ...pick,
        checked: pick.id === item.id
      }))
      this.activeSaveBtn = true
    },
    handleClose() {
      this.drawer = false
    },
    handleSave() {
      if (this.drawerIndex !== undefined) {
        const index = this.drawerIndex
        // 把当前 drawerConten 的 checked 状态更新回 storeWareVOList
        this.storeWareVOList[index].pickUpTimes = this.drawerConten.map(item => ({
          ...item
        }))
        const timeObj = this.storeWareVOList[index].pickUpTimes.filter(val => val.checked)[0]
        this.storeWareVOList[index].checkedPickUpStartTime = timeObj.pickUpStartTime
        this.storeWareVOList[index].checkedPickUpEndTime = timeObj.pickUpEndTime
        this.storeWareVOList[index].pickUpStartTimeDisplay = timeObj.pickUpStartTimeDisplay
      }
      this.drawer = false
      this.activeSaveBtn = false
      this.$emit("submitTime", this.storeWareVOList)
    },
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      if (isNaN(nums)) return ""
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    }
  }
}
